export const PATHS = {
  main: {
    login: '/login',
    logout: '/logout',
    requestPass: '/request-reset-password',
    resetPass: '/reset-password',
    resetPassSuccess: '/reset-password-success',
    verifyEmail: '/verify-email',
    npsScore: '/nps-score',
    dashboard: '/dashboard',
  },
  dashboard: {
    dashboard: '/dashboard',
    clients: '/clients',
    campaigns: '/campaigns',
    mission: '/mission',
    cities: '/cities',
    settings: '/settings',
    chat: '/chat',
    notFound: '/not-found',
    notAuthorised: '/not-authorised',
    userManagement: '/users',
    profile: '/profile',
    rosters: '/rosters',
  },
  userManagement: {
    userManagementDetailsCreate: '/create',
    userManagementDetailsView: '/:userId',
    userManagementDetailsEdit: '/:userId/edit',
  },
  profile: {
    edit: '/profile/edit',
  },
  cities: {
    edit: '/edit',
    add: '/add',
    ambassadors: '/ambassadors',
    ambassador: '/ambassadors/:ambassadorId',
    ambassadorEdit: '/ambassadors/:ambassadorId/edit',
    ambassadorUploadDocuments: '/ambassadors/:ambassadorId/upload-documents',
    inventory: '/dashboard/cities/:cityId/inventory',
    movements: '/dashboard/cities/:cityId/inventory/:inventoryId/movements',
    locations: '/locations',
    locationsH2H: '/handtohand',
    locationsLB: '/letterbox',
    locationsDM: '/directmail',
    view: '/',
    masterSchedule: '/global-planning',
    stats: '/stats',
    missionView: '/master-schedule/missions/:missionId',
    missionEdit: '/master-schedule/missions/:missionId/edit',
    pickup: '/pickup',
    manageOnboardingTimes: '/manage-onboarding-times',
    managePickupTimes: '/manage-pickup-times',
    letterboxBuilder: '/letterbox-builder',
    spies: '/spies/:spyId',
    spiesEdit: '/spies/:spyId/edit',
    spyUploadDocuments: '/spies/:spyId/upload-documents',
    liveMap: '/live-map',
    spy: '/spy',
  },
  clients: {
    add: '/add',
    clientView: '/:id',
    edit: '/:clientId/edit',
  },
  campaigns: {
    create: '/create',
    campaign: '/:campaignId',
  },
  campaign: {
    edit: '/edit',
    dashboard: '/dashboard',
    cityPlans: '/city-plans',
    cityPlanView: '/city-plans/:cityPlanId',
    rosterCreate: '/city-plans/:cityPlanId/rosters/create',
    rosterEdit: '/city-plans/:cityPlanId/rosters/:rosterId/edit',
    missionView: '/master-schedule/missions/:missionId',
    rosterMissionView:
      '/city-plans/:cityPlanId/rosters/:rosterId/missions/:missionId',
    letterboxMissionsMissionView: '/city-plans/:cityPlanId/missions/:missionId',
    letterboxMissionsMissionEdit:
      '/city-plans/:cityPlanId/missions/:missionId/edit',
    missionEdit: '/master-schedule/missions/:missionId/edit',
    rosterMissionEdit:
      '/city-plans/:cityPlanId/rosters/:rosterId/missions/:missionId/edit',
    cityPlanCreate: '/city-plans/create',
    masterSchedule: '/master-schedule',
    bonusResults: '/bonus-results',
    managePaidAmounts: '/manage-paid-amounts',
    clientQuestions: '/client-questions',
    liveMap: '/live-map',
  },
  // The same as the campaign route but without the unnecessary url params
  mission: {
    rosterMissionView: '/:missionId',
    missionEdit: '/:missionId/edit',
    rosterMissionEdit: '/:missionId/edit',
  },
  settings: {
    documentation: '/document-types',
    documentEdit: '/document-types/:id/edit',
    documentCreate: '/document-types/create',
    invoiceExport: '/invoice-export',
    legalDocumentation: '/legal-documents',
    legalDocumentationEdit: '/legal-documents/edit/:id',
    legalDocumentationCreate: '/legal-documents/create',
    tagsManagement: '/tags-management',
    tagsManagementEdit: '/tags-management/edit/:id',
    tagsManagementCreate: '/tags-management/create',
    npsScore: '/nps-score',
  },
  chat: {},
  cityPlan: {
    rosterView: '/rosters/:rosterId',
    letterboxMissions: '/missions',
    cityPlanEdit: '/edit',
  },
}



// WEBPACK FOOTER //
// ./src/Config/Routing/paths.js